module.exports = __webpack_public_path__ + "img/dynamicnumbering.ea2be0a4.svg";